import { createMuiTheme } from '@material-ui/core/styles';
import { breakpoints } from '@99designs/ui/settings';

export const materialUiAppBarHeight = '48px';

// Create a theme instance.
const materialTheme = createMuiTheme({
    typography: {
        fontFamily: 'Atlas Grotesk Web, sans-serif',
    },
    breakpoints: {
        values: {
            xs: breakpoints.small[0],
            sm: breakpoints.medium[0],
            md: breakpoints.normal[0],
            lg: breakpoints.large[0]!,
            xl: 1920,
        },
    },
    overrides: {
        MuiTableCell: {
            root: {
                borderBottom: 'inherit',
                fontSize: 'inherit',
            },
            footer: {
                color: 'inherit',
                fontSize: 'inherit',
                lineHeight: 'inherit',
            },
        },
    },
});

export default materialTheme;
